import React, { useState } from 'react';

import ProcurementPoliciesEditForm from './ProcurementPoliciesEditForm';

import Button from 'CommonComponents/Button';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ProcurementPoliciesEditModal(props) {
    const [policyIsUpdated, setPolicyIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setPolicyIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    const close = () => {
        if (policyIsUpdated || requestFailed) {
            internalSuccessHandler();
        } else {
            internalCloseHandler();
        }
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader title={$t('Edit Policy Step')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {Object.keys(props.policy).length > 0 && (
                    <div className="modal__form-container">
                        <div className={!policyIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                            <ProcurementPoliciesEditForm
                                policy={props.policy}
                                updateUrl={props.policiesUpdateUrl}
                                internalCloseHandler={internalCloseHandler}
                                setPolicyIsUpdated={setPolicyIsUpdated}
                                request={request}
                            />
                        </div>
                        <div className={policyIsUpdated ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                            <label className="modal__msg modal__text-color">
                                {$t('{{policy_total_cost}} updated', { policy_total_cost: props.policy.total_cost })}
                            </label>
                        </div>
                        <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                            <label className="modal__msg modal__error-text-color">
                                {$t('{{policy_total_cost}} could not be updated', { policy_total_cost: props.policy.total_cost })}
                            </label>
                        </div>

                        {(policyIsUpdated || requestFailed) && (
                            <div className="modal__footer">
                                <Button variant="secondary" onClick={internalSuccessHandler}>
                                    {$t('Close')}
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
}
